import { KtuinProductType } from '@/components/modules/Application/components/Cart/KtuinCart/types/KtuinProductType';

const others = '/assets/ktuin/icon-category-others.png';
const iphone = '/assets/ktuin/icon-product-iphone.png';
const ipad = '/assets/ktuin/icon-product-ipad.png';
const mac = '/assets/ktuin/icon-product-mac.png';
const appleWatch = '/assets/ktuin/icon-product-watch.png';
const airpods = '/assets/ktuin/icon-product-airpods.png';

const images: Record<KtuinProductType, string> = {
  [KtuinProductType.OTHERS]: others,
  [KtuinProductType.IPHONE]: iphone,
  [KtuinProductType.IPAD]: ipad,
  [KtuinProductType.MAC]: mac,
  [KtuinProductType.APPLE_WATCH]: appleWatch,
  [KtuinProductType.AIRPODS]: airpods,
};

interface KtuinProductIconProps {
  type: KtuinProductType;
  size?: number;
}

export const KtuinProductIcon = ({ type, size = 26 }: KtuinProductIconProps) => {
  return <img src={images[type]} style={{ width: `${size}px`, height: 'auto' }} />;
};
